import React from 'react';
import './Home.css'

const SubBanner = () => {
    return (
        <div className='hero md:rounded-2xl rounded-none mx-auto md:mt-[-150px] relative md:z-50 p-4 md:p-6 md:w-5/6'>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 justify-items-center'>
                <div data-aos='fade-right' data-aos-delay='100' data-aos-duration='800' className="card w-80 bg-gradient-to-r from-info to-blue-200 text-info-content text-center">
                    <div className="card-body">
                        <figure>
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-info-content" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                            </svg>
                        </figure>

                        <h2 className="text-2xl">Visit Us</h2>
                        <p>For Extra Details And big deals You can visit offices</p>

                    </div>
                </div>
                <div data-aos='fade-up' data-aos-delay='300' data-aos-duration='800' className="card w-80 bg-gradient-to-r from-primary to-yellow-300 text-primary-content text-center">
                    <div className="card-body">
                        <figure>
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-orange-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                            </svg>
                        </figure>
                        <h2 className="text-2xl">Purchese Lens</h2>
                        <p>We are the most Reputated and trusted manufacturers of lens</p>
                    </div>
                </div>
                <div data-aos='fade-left' data-aos-delay='100' data-aos-duration='800' className="card w-80 bg-gradient-to-r from-secondary to-emerald-400 text-secondary-content text-center">
                    <div className="card-body">
                        <figure>
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-secondary-focus" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
                                <path strokeLinecap="round" strokeLinejoin="round" d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
                            </svg>
                        </figure>
                        <h2 className="text-2xl">Grow Business</h2>
                        <p>we providing you support and advice to grow your business</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubBanner;